import { render, staticRenderFns } from "./FacialComparisonProviderChart.vue?vue&type=template&id=2adc1be0&"
import script from "./FacialComparisonProviderChart.vue?vue&type=script&lang=js&"
export * from "./FacialComparisonProviderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports